import React from "react";
import {
  StyledPreviousFeaturedMatch,
  StyledPreviousFeaturedMatchWrapper,
} from "./StyledPreviousFeaturedMatch";
import MatchDataLayer from "../../../mls-match-list/components/MatchDataLayer";
import { formatScores, useMatchData } from "../../../mls-match-list/utils";
import AppleMatchBroadcaster from "../../../shared/components/AppleMatchBroadcaster/AppleMatchBroadcaster";
import MatchTile from "../../../shared/components/MatchTile/MatchTile";
import { Link } from "../../../shared/components/Link/Link";
import StatusStamp from "../../../shared/components/StatusStamp/StatusStamp";
// import useMergedMatch from "./useMergedMatch";
import { StyledMatchLink } from "./MatchLink/StyledMatchLink";

const MAX_XXS_ABBREVIATED_LENGTH = 3;

function PreviousFeaturedMatch({ mlsMatch, forgeMatch, showLiveDot, isExtraSmallContainer }) {
  return (
    <StyledPreviousFeaturedMatch className="mls-c-featured-match__prev">
      <MatchDataLayer
        useEmptyClasses
        useMatchData
        forgeMatch={forgeMatch}
        statsAPIMatch={mlsMatch}
        matchSportecId={mlsMatch?.match_id}
      >
        <FeaturedMatch
          showLiveDot={showLiveDot}
          isExtraSmallContainer={isExtraSmallContainer}
        />
      </MatchDataLayer>
    </StyledPreviousFeaturedMatch>
  );
}

export default PreviousFeaturedMatch;

function FeaturedMatch({ position, showLiveDot, isExtraSmallContainer }) {
  const {
    status,
    slug,
    matchPageUrl,
    appleSubscriptionTier,
    appleStreamURL,
    winnerStatus,
    matchDateTime,
    homeClubData,
    awayClubData,
  } = useMatchData();


  const { isHomeWinner, isAwayWinner } = winnerStatus || {};


  const homeScore = homeClubData?.score;
  const awayScore = awayClubData?.score;

  const trackingData = {
    id: slug,
    creative: "match",
    position,
  };

  const trackingClickData = {
    clickItem: "match",
    match: slug,
    matchState: status?.abbreviation,
  };

  const abbreviatePostMatch =
    isExtraSmallContainer &&
    (homeClubData?.abbreviation?.length > MAX_XXS_ABBREVIATED_LENGTH ||
      awayClubData?.abbreviation?.length > MAX_XXS_ABBREVIATED_LENGTH);

  return (
    <StyledPreviousFeaturedMatchWrapper
      className="mls-c-vertical-match"
      data-tracking-block-impression={JSON.stringify(trackingData)}
      data-tracking-block-click={JSON.stringify(trackingClickData)}
    >
      <StatusStamp
        time={matchDateTime?.date}
        abbreviation={status?.abbreviation}
        showLiveDot={showLiveDot}
        abbreviatePostMatch={abbreviatePostMatch}
      />
      <StyledMatchLink>
        <Link url={matchPageUrl}>
          <MatchTile
            status={status}
            homeClubData={homeClubData}
            awayClubData={awayClubData}
            isHomeWinner={isHomeWinner}
            isAwayWinner={isAwayWinner}
            homeScore={homeScore}
            awayScore={awayScore}
            hasAbbreviation
          />
        </Link>
      </StyledMatchLink>
      <AppleMatchBroadcaster
        status={status}
        broadcaster={appleSubscriptionTier}
        url={appleStreamURL}
        matchPageUrl={matchPageUrl}
      />
    </StyledPreviousFeaturedMatchWrapper>
  );
}
